var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-5"},[_c('p',{staticClass:"text-secondary"},[_vm._v("4"),_c('i',{staticClass:"fa-regular fa-grin-beam-sweat"}),_vm._v("4")]),_c('p',{staticClass:"text-secondary"},[_vm._v("The page you are looking for cannot be found.")])])
}]

export { render, staticRenderFns }